import React from "react";

import { useTheme } from "../../../../context/theme";
import useShadow from "../../../../styles/shadows/useShadow";
import { Box } from "../../../layout";
import { AvatarSize, avatarSizeToStylesMap, AvatarState } from "../consts";

type Props = {
  avatarState: AvatarState;
  avatarSize: AvatarSize;
  children: React.ReactNode;
};
export default function OuterCircle({
  avatarState,
  avatarSize,
  children
}: Props) {
  const theme = useTheme();
  const boxShadow = useShadow("small");

  const { insetAndBorderWidth } = avatarSizeToStylesMap[avatarSize];

  return (
    <Box
      borderRadius="xxxlarge"
      borderColor={
        avatarState === "outline"
          ? theme.foreground
          : theme["primary-high-content"]
      }
      borderStyle="solid"
      borderWidth={avatarState === "default" ? "none" : insetAndBorderWidth}
      margin={avatarState === "default" ? insetAndBorderWidth : undefined}
      width="max-content"
      boxShadow={boxShadow}
    >
      {children}
    </Box>
  );
}
